export default __webpack_public_path__ + "assets/ifu_icon.png";